import { Model } from "react3l-common";
import { Field, MomentField } from "react3l-decorators";
import type { Moment } from "moment";
import { Site } from "models/Site";
import { Status } from "models/Status";
import { ResponsibilityRoleMapping } from "models/ResponsibilityRoleMapping";
import { ResponsibilityAppUserGroupingMappings } from "models/ResponsibilityAppUserGroupingMappings/ResponsibilityAppUserGroupingMappings";

export class Responsibility extends Model {
  @Field(Number)
  public id?: number;

  @Field(String)
  public code?: string;

  @Field(String)
  public name?: string;

  @Field(Number)
  public statusId?: number;

  @Field(Boolean)
  public isTendering?: boolean = false;

  @Field(Number)
  public siteId?: number;

  @Field(String)
  public rowId?: string;

  @MomentField()
  public createdAt?: Moment;

  @MomentField()
  public updatedAt?: Moment;

  @MomentField()
  public deletedAt?: Moment;

  public site?: Site;

  public status?: Status;

  public responsibilityRoleMappings?: ResponsibilityRoleMapping[];

  public responsibilityAppUserGroupingMappings?: ResponsibilityAppUserGroupingMappings[]
}
